import get from 'lodash/get'
import api from '~/api'

const state = {
  users: {},
}

const getters = {
  users: s => get(s.users, 'items', []),
  total: s => get(s.users, 'pagination.total_items', 0),
}

const mutations = {
  SET_USERS(state, serverResponse) {
    state.users = serverResponse
  },
}

const actions = {
  async getUsers({ commit }) {
    const [error, result] = await api.get('/users?perPage=1') // We only need to get Total

    if (result) {
      commit('SET_USERS', result)
    }

    return [error, result]
  },
}

export default {
  state,
  getters,
  mutations,
  actions,
  namespaced: true,
}
